<template>
  <div class="content">
    <img class="title_img" :src="require('@/assets/img/welcome_new.jpg')" alt="" />
    <van-form @submit="onSubmit">
      <van-field
        v-model="phoneNumber"
        type="tel"
        label=""
        placeholder="请输入手机号"
        :rules="[{ validator, message: '请输入11位手机号' }]"
        maxlength="13"
        @keyup="phoneUp"
      />
      <div style="margin: 16px">
        <van-button round block type="danger" native-type="submit">开始吧</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { getResumeldByPhoneApi } from "@/api/interview";
export default {
  data() {
    return {
      phoneNumber: "",
      emp_id:''
    };
  },
  mounted(){
    this.emp_id = this.$route.query.emp_id
  },
  methods: {
    phoneUp(){
       let phoneNum = this.phoneNumber
    },
    onSubmit() {
      const phone = this.phoneNumber.split(" ");
      const params = {
        phone: phone.join(""),
        audition: 1
      };
      getResumeldByPhoneApi(params).then((res) => {
        if(res.errNo===0){
            sessionStorage.setItem('ID',res.result)
            sessionStorage.setItem('phoneNumber',phone.join(""))
            this.$router.push({path:"/interviews/perinfo",query:{emp_id:this.emp_id}})
        }
      });
    },
    validator(val) {
      const phone = val.split(" ");
      const reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      return reg.test(phone.join(""));
    },
  },
  watch: {
    // 改变手机号为344格式
    phoneNumber(newVal, oldVal) {
      this.phoneNumber = newVal.length > oldVal.length ? newVal.replace(/\s/g, '').replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3') : this.phoneNumber.trim()
    },
  },
};
</script>

<style scoped lang="less">
.title_img {
  width: 100%;
  padding-bottom: 36px;
}
/deep/ input::-ms-input-placeholder {
  text-align: center;
  color: #999999;
}
/deep/ input::-webkit-input-placeholder {
  text-align: center;
  color: #999999;
}
/deep/ input {
  text-align: center;
}
/deep/ .van-button--block {
  border-radius: 10px;
}
/deep/ .van-field__error-message {
  text-align: center;
}
/deep/ .van-cell::after {
  border-bottom: 1px solid #999999;
}
</style>
